import {Component, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {TabsService} from "../../../services/tabsService";
import {CalculationsControlService} from "../../../services/calculations-control.service";
import {MapService} from "../../../services/map.service";
import {PointsService} from "../../../services/points.service";
import {BsModalRef} from "ngx-bootstrap/modal";
import {NavaidsCoChannelsService} from "../../../services/navaids-co-channels.service";
import {coverageDTO, coverageDTOModal} from "../../../models/coverageDTO";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {GritDynamicTableComponent} from "../../../utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import {GritFeature} from "../../../models/grit/grit.feature";
import {DeviceModel, InterferenceTestDeviceModel} from "../../../models/grit/grit.device-model";
import {ReceiverModel} from "../../../models/grit/grit.receiver-model";
import {FeatureType} from "../../../models/EnumTypes";
import {ModalControlService} from "../../../services/modal-control.service";
import {DistanceField} from "../../../models/grit/grit.variable-unit-fields";
import {ConfigurationService} from "../../../services/configuration.service";
import {CalculationSettingsModel} from "../../../models/configuration";
import {ProjectService} from "../../../services/project.service";
import {features} from "process";
import {ImpactAssessmentDTO} from "../../../models/grit/grit.calculation-dto";
import {GritReceiverService} from "../../../services/grit/grit.receiver.service";
import {
  GritDynamicTableFeaturesComponent
} from "../../../utils/grit/grit-dynamic-table-features/grit-dynamic-table-features.component";

@Component({
  selector: 'app-impact-calculation',
  templateUrl: './impact-calculation.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class  ImpactCalculationComponent implements OnInit {
  // @Input() title : string;
  // @Input() coverage_type : string;

  impactAssessment = {
    name: "",
    maxAltitude: new DistanceField(),
    minAltitude: new DistanceField(),
    altitudeInterval: new DistanceField(),
  }

  readonly forbiddenSubstringName = TabsService.SEPARATOR;

  @ViewChild(GritDynamicTableFeaturesComponent) table : GritDynamicTableFeaturesComponent

  constructor(public calculationControlService : CalculationsControlService,
              public configurationService : ConfigurationService,
              public bsModalRef : BsModalRef,
              public mapService : MapService,
              public pointsService : PointsService,
              protected receiverService : GritReceiverService,
              private modalService : ModalControlService,
              private projectService : ProjectService) {}

  ngOnInit(): void {
    this.impactAssessment.maxAltitude.feets = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitude
    this.impactAssessment.minAltitude.feets = this.configurationService.currentConfiguration.defaultAltitudes.minAltitude
    this.impactAssessment.altitudeInterval.feets = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrement
  }

  _receivers:  ReceiverModel[] = this.receiverService.receivers.filter(receiver => receiver.calculationUse);
  get receivers(){return this._receivers}

  _devices: GritFeature<InterferenceTestDeviceModel>[];
  selectAll = false;
  get devices(){return this._devices}
  set devices(devices : GritFeature<InterferenceTestDeviceModel>[]){
    if (devices.length > 0){
      this._devices = devices;
      this.selectAll = true;
    }
    else{
      this._devices = this.pointsService.getGritFeatures(FeatureType.Device)
    }
  }
  cancelCoverage():void{
  this.bsModalRef.hide();
}

  ok():void{
    if (this.table.selectedFeatures.length == 0 || this.receivers.length == 0 ){
      return;
    }

    let impactAssessmentDTO = new ImpactAssessmentDTO(
      `${this.impactAssessment.name}_${this.impactAssessment.minAltitude.feets}_${this.impactAssessment.altitudeInterval.feets}_${this.impactAssessment.maxAltitude.feets}`,
      this.impactAssessment.minAltitude.feets / 100,
      this.impactAssessment.maxAltitude.feets / 100,
      this.impactAssessment.altitudeInterval.feets / 100,
      CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration),
      this.projectService.selectedProject.id
    );

    impactAssessmentDTO.calculationSettings.rangeLimitation = "FSPL";
    impactAssessmentDTO.calculationSettings.useSectorization = true;

    this.receivers.forEach((receiver : ReceiverModel)=> {
      impactAssessmentDTO.addDevices(this.table.selectedFeatures as GritFeature<InterferenceTestDeviceModel>[], receiver)
    })

    this.calculationControlService.impactAssessmentCalculationInitialization(impactAssessmentDTO);

    this.bsModalRef.hide();
  }

  singleLevel(active: boolean){
    if (active){
      this.impactAssessment.maxAltitude = this.impactAssessment.minAltitude;
      this.impactAssessment.minAltitude.feets = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitude
      this.impactAssessment.altitudeInterval.feets = 0;
    }
    else{
      this.impactAssessment.maxAltitude = new DistanceField();
      this.impactAssessment.maxAltitude.feets = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitude;
      this.impactAssessment.minAltitude.feets = this.configurationService.currentConfiguration.defaultAltitudes.minAltitude;
      this.impactAssessment.altitudeInterval.feets = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrement;
    }
  }

  cancel(){
    this.bsModalRef.hide();
  }

  protected readonly GritDynamicTableType = GritDynamicTableType;
  protected readonly GritDynamicTableMode = GritDynamicTableMode;
  protected readonly ReceiverModel = ReceiverModel;
}
